export default {
  businessThresholdConfig: 'Business Thresholds',
  category: 'Category',
  capacity: 'ULD Capacity',
  warehouse: 'Warehouse Difference',
  profit: 'Profit Analysis',
  alert: 'Deadline Alerts',
  security: 'Login Security',
  hours: 'h',
  minutes: 'min',
  times: ' times',
  save: 'Save',
  cancel: 'Cancel',
  cancelOrder: 'Cancel Order',
  confirm: 'Confirm',
  ok: 'OK',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  view: 'View',
  search: 'Search',
  reset: 'Reset',
  submit: 'Submit',
  close: 'Close',
  back: 'Back',
  export: 'Export',
  exportOrders: 'Batch Export Orders',
  import: 'Import',
  download: 'Download',
  upload: 'Upload',
  refresh: 'Refresh',
  operation: 'Action',
  actions: 'Actions',
  status: 'Status',
  remark: 'Remark',
  description: 'Description',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  none: 'None',
  loading: 'Loading...',
  noData: 'No Data',
  success: 'Operation succeeded',
  failed: 'Operation failed',
  saveSuccess: 'Saved successfully',
  deleteSuccess: 'Deleted successfully',
  updateSuccess: 'Updated successfully',
  confirmDelete: 'Are you sure to delete this record?',
  confirmAction: 'Are you sure to perform this action?',
  required: 'Required',
  pleaseInput: 'Please input',
  pleaseSelect: 'Please select',
  language: 'Language',
  switchLanguage: 'Switch Language',
  switchToChinese: 'Switch to Chinese',
  switchToEnglish: 'Switch to English',
  chinese: '中文',
  english: 'English',
  logout: 'Logout',
  changePassword: 'Change Password',
  welcome: 'Welcome',
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  custom: 'Custom',
  total: 'Total',
  count: 'Count',
  name: 'Name',
  code: 'Code',
  type: 'Type',
  createTime: 'Created At',
  updateTime: 'Updated At',
  createUser: 'Created By',
  serialNo: 'No.',
  unlinked: 'Unlinked',
  currentStatus: 'Current Status',
  complete: 'Complete',
  revokeComplete: 'Revoke Completion',
  locked: 'Locked',
  unlocked: 'Unlocked',
  lock: 'Lock',
  unlock: 'Unlock',
  fill: 'Fill',
  detail: 'Detail',
  to: 'to',
  activate: 'Activate',
  deactivate: 'Deactivate',
  newCustomer: 'New Customer',
  editCustomer: 'Edit Customer',
  enable: 'Enable',
  disable: 'Disable',
  newUser: 'New User',
  editUser: 'Edit User',
  resetPassword: 'Reset Password',
  forceChangePasswordOnReset: 'Force password change on first login after reset',
  newDictionary: 'New Dictionary',
  editDictionary: 'Edit Dictionary',
  newItem: 'New Item',
  editItem: 'Edit Item',
  newAgreement: 'New Agreement',
  editAgreement: 'Edit Agreement',
  newAgreementOrder: 'New Agreement Entrust No.',
  editAgreementOrder: 'Edit Agreement Entrust No.',
  agreementDescription: 'Agreement Description',
  addPalletType: '+ Add Pallet Type',
  regenerateSubOrders: 'Re-split',
  batchGenerateProductOrders: 'Batch Generate Product Orders',
  everyMonth: 'Every month',
  confirmGenerate: 'Confirm Generate',
  keepCurrentAdjustment: 'Keep Current',
  // system actions
  newRole: 'New Role',
  editRole: 'Edit Role',
  assignPermission: 'Assign Permission',
  newPermission: 'New Permission',
  editPermission: 'Edit Permission',
  newChildPermission: 'New Child Permission',
  permissionTree: 'Permission Tree',
  permissionDetail: 'Permission Detail',
  childPermissionList: 'Child Permissions',
  newOrganization: 'New Organization',
  editOrganization: 'Edit Organization',
  orgStructure: 'Organization Structure',
  topLevel: 'Top',
  topOrg: 'Top-level Organization',
  noOrgData: 'No organization data',
  queryAccountStatus: 'Query Account Status',
  unlockAccount: 'Unlock Account',
  serialNumberConfig: 'Serial Number Config',
  bubbleConfig: 'Bubble Config',
  chargeWeightRuleConfig: 'Chargeable Weight Rounding Rule',
  modify: 'Modify',
  pieceDetail: 'Piece Detail',
  addRow: 'Add Row',
  recognizeAndFill: 'Parse and Fill',
  noReceivableDetail: 'No receivable details',
  noPayableDetail: 'No payable details',
  actualWarehouse: 'Actual Warehouse',
  difference: 'Difference',
  additionalInfo: 'Additional Info',
  autoCalculated: 'Auto-calculated',
  newBizOrder: 'New Biz Order',
  viewOtherTabs: 'View Other Tabs',
  loadingMore: 'Loading more...',
  scrollToLoadMore: 'Scroll to load more',
  receivable: 'Receivable',
  pendingBackfill: 'Pending Backfill',
  backfilled: 'Backfilled',
  other: 'Other',
  bubble: 'Bubble',
  bubbleRatioPrefix: 'Bubble Ratio 1:',
  bubbleShareLabel: '{ratio} Bubble',
  discountAmount: 'Discount Amount',
  recalc: 'Recalculate',
  cancelBubble: 'Cancel Bubble',
  bubbleQuoteCalc: 'Bubble Quote Calc',
  localPayable: 'Local Payable',
  originalPrice: 'Original Price',
  includesReceivableDetail: 'Incl. receivable detail',
  copyNew: 'Copy as New',
  cargoChange: 'Cargo Change',
  revertToDraft: 'Revert to Draft',
  submitPendingBooking: 'Submit for Booking',
  confirmNew: 'Confirm New',
  create: 'Create',
  applyToQuote: 'Apply to Quote',
  applyToWeight: 'Apply to Weight',
  // entry/dialogs
  iSee: 'I See',
  confirmLock: 'Confirm Lock',
  confirmDissolve: 'Confirm Dissolve',
  submitHandling: 'Submit Handling',
  editMawb: 'Edit MAWB',
  newMawb: 'New MAWB',
  newProductOrder: 'New Product Order',
  editProductOrder: 'Edit Product Order',
  confirmCreate: 'Confirm Create',
  reselect: 'Reselect',
  dissolve: 'Dissolve',
  // entry/components/ChangeRequestDrawer
  approveChange: 'Approve Change',
  rejectChange: 'Reject Change',
  confirmReject: 'Confirm Reject',
  // entry/components/CargoModeView
  unknown: 'Unknown',
  // entry/components/RightPanel
  advancedFilter: 'Advanced Filter',
  filter: 'Filter',
  batchMatch: 'Batch Match',
  cancelSelection: 'Cancel Selection',
  // entry/components/WarehouseConfirmDrawer
  confirmAdd: 'Confirm Add',
  // entry/components/PendingWarehouseZone
  cancelMatch: 'Cancel Match',
  gotIt: 'Got it',
  confirmWarehouse: 'Confirm Warehouse',
  // entry/RouteEntryView deviation dialog
  accept: 'Accept',
  adjust: 'Adjust',
  reject: 'Reject',
  dialog: {
    bizOrderDetail: 'Business Order Detail',
    bizOrderCreateTitle: 'New Business Order',
    bizOrderEditTitle: 'Edit Business Order',
    bizOrderCopyTitle: 'Copy as New Business Order',
  },
  tab: {
    basicInfo: 'Basic Info',
    freightInfo: 'Freight Info',
    cargoInfo: 'Cargo Info',
    warehouseData: 'Warehouse Data',
    relationInfo: 'Relations',
    incomeInfo: 'Income',
    costProfit: 'Cost & Profit',
    profitShare: 'Profit Share',
    receivableDetail: 'Receivables',
    payableDetail: 'Payables',
    operationLog: 'Operation Log',
    salesCost: 'Sales Cost',
    trunkCost: 'Trunk Cost',
    profitShareCombined: 'Gross Profit & Share',
    financeDetail: 'Finance Summary',
    cargoList: 'Cargo List',
    customerInfo: 'Customer Info',
  },
  login: {
    subtitle: import.meta.env.VITE_LOGIN_SUBTITLE_EN || 'Air Route Operations System (Test)',
    button: 'Login',
    changePasswordTitle: 'Change Password',
    mustChangeAlert: 'Your password is the system default, please change it immediately',
    confirmModify: 'Confirm',
    clickToRefresh: 'Click to refresh',
  },
  // entry/components/CenterPanel/MasterOrderList
  addMawb: 'Claim MAWB',
  switchToCompactMode: 'Switch to Compact Mode',
  switchToCardMode: 'Switch to Card Mode',
  // entry/components/CenterPanel/MasterOrderItem/HawbCard
  cancelWarehouse: 'Cancel Warehouse',
  handleDiff: 'Handle Diff',
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
  inputActualData: 'Input Actual Data',
}
